import React from "react";

const Header = () => {
  return (
    <header className="bg-black/80 px-4 py-6">
      <div className="flex items-center justify-center max-w-2xl mx-auto w-full">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full border-2 border-accent p-0.5">
            <img
              src="/images/cara.webp"
              alt="Tomas"
              className="w-full h-full rounded-full object-cover"
            />
          </div>
          <div>
            <h1 className="text-lg font-bold text-white">Tomás Solar</h1>
            <p className="text-xs text-accent font-medium">Desarrollador Web</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
